import React from 'react';
import { connect } from 'react-redux';
import TransactionBanner from './TransactionBanner';

const TransactionBannerBlock = ({data, context, bannerDetails, dealType, marketCode}) => {
    return (
      <TransactionBanner
        bannerDetails={bannerDetails}
        data={data}
        context={context}
        dealType={dealType}
        marketCode={marketCode}
      />
    );
}
 

const mapStateToProps = (state) => {
    return {
      bannerDetails: state.cellcomTransactionSummary.transactionData.bannerDetails,
      dealType: state.cellcomTransactionSummary.transactionData.dealType,
      marketCode: state.domain?.MarketCode,
    };
  };
  
  
  export default connect(mapStateToProps, null)(TransactionBannerBlock);